import { render, staticRenderFns } from "./NewEmail.vue?vue&type=template&id=2c56d42f&scoped=true"
import script from "./NewEmail.vue?vue&type=script&lang=js"
export * from "./NewEmail.vue?vue&type=script&lang=js"
import style0 from "./NewEmail.vue?vue&type=style&index=0&id=2c56d42f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56d42f",
  null
  
)

export default component.exports